/**
 *  Дополнителное поведение для стандартных компонентов, 
 *  которое не требует отдельного класса и невозможно реализовать в CSS
 */

export default{
    init(){
        this.compressedTextArea();
    },

    compressedTextArea(){
        $('.bb-standard-textarea.compressed').on('click', function(){
            $(this).addClass('focused');
        });
        $('.bb-standard-textarea.compressed').on('blur', function(){
            $(this).removeClass('focused');
        });
    }
}